import { call } from '../@';

export default async function sendCaseHandlerNotification(id: string) {
	return await call('transaction-sendCaseHandlerNotification', { id });
}
